module.exports = __webpack_public_path__ + "static/media/Debora.034da261.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/make_over/Debora.jpg
// module id = 315
// module chunks = 0